// File: components/Campaigns.tsx

import React, { useEffect,useState } from "react";
import baseUrl from "../../api/universalApi";

const Campaigns = ({ creatorData }) => {
  //console.log("Creator Data:", creatorData);
  const [campaigns, setCampaigns] = useState([]);

  useEffect(() => {
    // This effect can be used to fetch or manipulate data related to campaigns
    const fetchCampaignsData = async (id) => {
      try {
        // Simulate fetching campaigns data
        const response = await fetch(
          `${baseUrl}/api/campaign/getCampaigns/${id}`
        );
        if (!response.ok) {
          throw new Error("Failed to fetch campaigns data");
        }
        const data = await response.json();
        console.log("Fetched Campaigns Data:", data);
        setCampaigns(data);
      } catch (error) {
        console.error("Error fetching campaigns data:", error);
      }
    };
    fetchCampaignsData(creatorData?._id);
  }, [creatorData?._id]);

  // const campaigns = [
  //   {
  //     campaign: "Summer Sale Launch",
  //     platform: "Instagram",
  //     brand: "Brand A",
  //     pocEmail: "sophia@brand-a.com",
  //     vrfFile: "https://example.com/vrf/summer-sale.pdf",
  //     comments: "Kickoff campaign for summer collection.",
  //   },
  //   {
  //     campaign: "Back to School",
  //     platform: "YouTube",
  //     brand: "Brand B",
  //     pocEmail: "ethan@brand-b.com",
  //     vrfFile: "https://example.com/vrf/back-to-school.pdf",
  //     comments: "Targeting students and parents.",
  //   },
  //   {
  //     campaign: "Holiday Giveaway",
  //     platform: "TikTok",
  //     brand: "Brand C",
  //     pocEmail: "olivia@brand-c.com",
  //     vrfFile: "https://example.com/vrf/holiday-giveaway.pdf",
  //     comments: "Engagement-focused giveaway.",
  //   },
  //   {
  //     campaign: "Product Launch",
  //     platform: "Facebook",
  //     brand: "Brand D",
  //     pocEmail: "liam@brand-d.com",
  //     vrfFile: "https://example.com/vrf/product-launch.pdf",
  //     comments: "Major product launch event.",
  //   },
  //   {
  //     campaign: "Spring Refresh",
  //     platform: "Twitter",
  //     brand: "Brand E",
  //     pocEmail: "ava@brand-e.com",
  //     vrfFile: "https://example.com/vrf/spring-refresh.pdf",
  //     comments: "Promoting new arrivals.",
  //   },
  // ];

  return (
    <div className="p-4 overflow-x-auto">
      <h3>Track All Campaigns</h3>
      <table className="min-w-full border-collapse bg-white rounded-xl overflow-hidden shadow-sm">
        <thead>
          <tr className="text-left text-sm text-gray-600 bg-gray-50">
            <th className="px-6 py-3">Campaign</th>
            <th className="px-6 py-3">Platform</th>
            <th className="px-6 py-3">Brand</th>
            <th className="px-6 py-3">POC Email</th>
            <th className="px-6 py-3">VRF File</th>
          </tr>
        </thead>
        <tbody className="text-sm text-gray-700">
          {campaigns.map((row, i) => (
            <tr key={i} className="border-t">
              <td className="px-6 py-4 font-medium text-gray-900">
                {row.campaignTitle}
              </td>
              <td className="px-6 py-4">{row.platform}</td>
              <td className="px-6 py-4">{row.brandName}</td>
              <td className="px-6 py-4">{row.pocEmail}</td>
              <td className="px-6 py-4">
                <a
                  href={row.vrfFile}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-indigo-600 hover:underline"
                >
                  View VRF
                </a>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default Campaigns;
